import React, { Component } from "react";
import { Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import configData from "../config.json";
import "./Abha.css";

export default class ExistingABHAVerification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      requestId: sessionStorage.getItem("requestId"),
      AbhaProfile: {},
      abhanumber: "",
      aadharNumber: "",
      phrAddress: "",
    };
  }
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
       case "warning":
      toast.warning(msg); // 'warn' is used instead of 'warning'
        break;
      default:
        toast.success(msg);
    }
  };
  componentDidMount() {
    this.ResponseHandler();
  }
  ResponseHandler = () => {
    const formData = new FormData();
    formData.append("requestId", this.state.requestId);
  
    fetch(configData.api_url + "C_Abhaverify/retriverequestId", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success" && data.detail) {
          const abhaDetails = data.detail;
  
          // If abhanumber and phrAddress are present directly
          this.setState({
            abhanumber: abhaDetails.abhanumber || "",      // set default if missing
            phrAddress: abhaDetails.phrAddress || "",
            aadharNumber: abhaDetails.aadharNumber || "",
            AbhaProfile: abhaDetails                      // optionally store full detail
          });
  
          sessionStorage.setItem("abhaProfileStatus", "success");
        } else {
          sessionStorage.setItem("abhaProfileStatus", "fail");
          this.showToast("Failed to retrieve ABHA details", "error");
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        this.showToast("Error retrieving details", "error");
      });
  };
  
//   ResponseHandler = () => {
//     const formData = new FormData();
//     formData.append("requestId", this.state.requestId);
  
//     fetch(configData.api_url + "C_Abhaverify/retriverequestId", {
//       method: "POST",
//       mode: "cors",
//       body: formData,
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         if (data.status === "success" && data.detail) {
//           const abhaDetails = JSON.parse(data.detail.abhaprofile);
//           const abhaProfile = abhaDetails.ABHAProfile;
  
//           if (abhaProfile) {
//             sessionStorage.setItem("abhaProfileStatus", "success");
//             this.setState({
//               AbhaProfile: abhaProfile,
//               abhanumber: abhaProfile.abhaNumber,     // ✅ corrected
//               phrAddress: abhaProfile.phrAddress,     // ✅ corrected
//             });
//           } else {
//             sessionStorage.setItem("abhaProfileStatus", "fail");
//           }
//         }
//       })
//       .catch((err) => {
//         console.error("Error fetching ABHA profile:", err);
//       });
//   };
  
//   ResponseHandler = () => {
//     var formData = new FormData();

//     formData.append("requestId", this.state.requestId);
//     fetch(configData.api_url + "C_Abhaverify/retriverequestId", {
//       method: "POST",
//       mode: "cors",
//       body: formData,
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         if (data.status === "success" && data.detail) {
//           const abhaDetails = JSON.parse(data.detail.abhaprofile);
//           // console.log(abhaDetails);
//           const abhaProfile = abhaDetails.ABHAProfile;
//           const abhanumber = data.detail.abhanumber;
//           const phrAddress = data.detail.phrAddress;
//           if (abhaProfile) {
//             sessionStorage.setItem("abhaProfileStatus", "success");
//             this.setState({
//               AbhaProfile: abhaProfile,
//               abhanumber: abhanumber,
//               phrAddress: phrAddress,
//             });
//           } else {
//             sessionStorage.setItem("abhaProfileStatus", "fail");
            
//           }
//         }
//       });
//   };
  HandleClick = () => {
    const { abhaAddress, aadharNumber, abhanumber } = this.state;
    sessionStorage.setItem("abhaAddress", abhaAddress);
    sessionStorage.setItem("aadharNumber", aadharNumber);
    sessionStorage.setItem("abhanumber", abhanumber);

    window.location.href = "/abhaaddresscreation";
  };
  handlenextClick = () => {
    const { abhanumber, aadharNumber } = this.state;
    const formData = new FormData();
    formData.append("requestId", this.state.requestId);
    fetch(configData.api_url + "C_Abhaverify/getAbhaProfile", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        sessionStorage.setItem("abhaAddress", this.state.phrAddress);
        sessionStorage.setItem("aadharNumber", aadharNumber);
        sessionStorage.setItem("abhanumber", abhanumber);
        this.showToast(data.message);

        if (data.status === "success") {
          window.location.href = "/abhanumberprofile";
        }
      });
  };

  handlenewClick = () => {
    sessionStorage.setItem("abhaAddress", 
      this.state.AbhaProfile.phrAddress);
    window.location = "./abhacreationan";
  };
  render() {
    return (
      <div>
         <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>
          Existing-ABHA
        </h3>
        <div className="row  widget_BG mt-2 existingabha d-flex">
        <div className="col-md-4">
        <Form.Group>
                <Form.Label><b>ABHA Number</b></Form.Label>

                <div ClassName="custom-calendar">
                  <Form.Control
                    type="text"
                    name="abhanumber"
                    id="abhanumber"
                    value={this.state.abhanumber}
                    disabled
                    className="form-control"
                  />
                </div>
                
              </Form.Group>
        </div>
        <div className="col-md-4">
          <Form.Label><b>ABHA Address</b></Form.Label>
          <div ClassName="custom-calendar">
            <Form.Control
              type="text"
              name="phrAddress"
              id="phrAddress"
              value={this.state.phrAddress}
              disabled
              className="form-control"
            />
          </div>
        </div>
        <div className="col-md-4 text-end">
        <br />
          <Button className="rounded-0 m-1" onClick={this.handlenewClick}>
              New ABHA Address
            </Button>
            <Button className="rounded-0 m-1" onClick={this.handlenextClick}>
              ABHA Profile
            </Button>
        </div>


        <div className='row' style={{height:"450px"}}></div>



        </div>
      </div>
    );
  }
}
